// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Fo6T","rootNoMargin":"styles_rootNoMargin__3POrL"};